import {
  ADDBIKEDETAILS,
  ADDBIKENUMBER,
  ALLBIKEDETAILS,
  BIKENUMFLAG,
  BIKE_INS_PRODUCT,
  BIKE_PREV_INS_LIST,
  BIKEQUICKQUOTES,
  CUSTOMER_DETAILS,
  ADD_VAHAN_DATA,
  CREATE_PROPOSAL,
  PAYMENT_REQUEST,
  SET_IDV,
  QUICKQUOE_VALUE,
  QUICKQUOTE_POST,
  KYC_STATUS,
  POLICY_PDF,
  RESET_BIKE,
  PREV_POLICY_DETAIL,
  SELECTED_QUOTE,
  SELECTED_LIFE_PLAN,
  COMPARE_QQ,
  SHORTLIST_QQ,
  ERROR_QUOTES,
  UAT_LOGIN,
  RESET_UAT,
  SELECTED_ADDONS,
  RESET_COMMON,
  TRANS_ID,
  ROUTE,
  TOKEN_EXPIRED,
  PAY_TILL_AGE,
  PAY_TILL_UPDATE,
  SEND_REQUEST,
  OTP_SENT,
  ADD_PRODUCT_TYPE,
} from "../actiontypes/NumBikeActiontypes";

const init = {
  isbikeno: false,
  // customerDetail: [],
  bikenum: "",
  bikeMakeData: {},
  isallbikedetails: false,
  insuranceproduct: [],
  previnslist: [],
  quickquotes: [],
  errquote: [],
  quickQuotePost: {},
  quoteInput: {},
  prevpolicydetail: {},
  createProposal: {},
  payRequest: {},
  idvValue: {},
  KycStatus: {},
  policypdf: {},
  TID: {},
};

export const numBikeReducer = (state = init, { type, payload }) => {
  switch (type) {
    case ADDBIKENUMBER:
      return { ...state, bikenum: payload, isbikeno: true };
    case BIKENUMFLAG:
      return { ...state, bikenum: "", isbikeno: false };
    case ADDBIKEDETAILS:
      return {
        ...state,
        bikeMakeData: payload,
        isallbikedetails: true,
      };
    case ALLBIKEDETAILS:
      return { ...state, isallbikedetails: true };
    case BIKE_INS_PRODUCT:
      return { ...state, insuranceproduct: payload };
    case BIKE_PREV_INS_LIST:
      return { ...state, previnslist: payload };
    case BIKEQUICKQUOTES:
      return { ...state, quickquotes: payload };
    case ERROR_QUOTES:
      return { ...state, errquote: payload };
    case QUICKQUOE_VALUE:
      return { ...state, quoteInput: payload };
    case QUICKQUOTE_POST:
      return { ...state, quickQuotePost: payload };
    // case CUSTOMER_DETAILS:
    //   return { ...state, customerDetail: payload };
    case PREV_POLICY_DETAIL:
      return { ...state, prevpolicydetail: payload };
    case SET_IDV:
      return { ...state, idvValue: payload };
    case CREATE_PROPOSAL:
      return { ...state, createProposal: payload };
    case PAYMENT_REQUEST:
      return { ...state, payRequest: payload };
    case KYC_STATUS:
      return { ...state, KycStatus: payload };
    case TRANS_ID:
      return { ...state, TID: payload };
    case POLICY_PDF:
      return { ...state, policypdf: payload };
    case RESET_BIKE:
      return init;
    default:
      return { ...state };
  }
};

const initCom = {
  vahanData: {},
  productType: null,
  customerDetail: [],
  selectedQuote: {},
  selectedAddons: [],
  selectedLifePlan: "",
  compare: [],
  shortlist: [],
  route: {},
  pospTokenExp: true,
  paytillAge: "",
  paytillUpdate: "",
  quoteRequest: false,
  trainingTime: "",
  otpsent: "",
};
export const QQcommon = (state = initCom, { type, payload }) => {
  switch (type) {
    case ADD_VAHAN_DATA:
      return { ...state, vahanData: payload };
    case ADD_PRODUCT_TYPE:
      return { ...state, productType: payload };
    case SEND_REQUEST:
      return { ...state, quoteRequest: payload?.quoteRequest };
    case CUSTOMER_DETAILS:
      return { ...state, customerDetail: payload };
    case SELECTED_QUOTE:
      return { ...state, selectedQuote: payload };
    case SELECTED_ADDONS:
      return { ...state, selectedAddons: payload };
    case SELECTED_LIFE_PLAN:
      return { ...state, selectedLifePlan: payload };
    case COMPARE_QQ:
      return { ...state, compare: payload };
    case SHORTLIST_QQ:
      return { ...state, shortlist: payload };
    case PAY_TILL_AGE:
      return { ...state, paytillAge: payload };
    case PAY_TILL_UPDATE:
      return { ...state, paytillUpdate: payload };
    case ROUTE:
      return { ...state, route: payload };
    case TOKEN_EXPIRED:
      return { ...state, pospTokenExp: payload };
    case OTP_SENT:
      return { ...state, otpsent: payload };
    case RESET_COMMON:
      return initCom;
    default:
      return { ...state };
  }
};
const initUAT = {
  uaLogin: {},
};
export const UatReducer = (state = initUAT, { type, payload }) => {
  switch (type) {
    case UAT_LOGIN:
      return { ...state, uaLogin: payload };
    case RESET_UAT:
      return init;
    default:
      return { ...state };
  }
};
